import apiUseCases from "@src/cloud-connect/api";
import { PatchDashboardPayload } from "@src/cloud-connect/api/dashboards-v2/patch-dashboard-v2";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { Dashboard } from "@src/types/dashboards";

export interface PatchDashboardV2Result {
  success: boolean;
  data?: Dashboard;
  error?: string;
}

export const patchDashboardV2UseCase = async (
  dashboardId: string,
  payload: PatchDashboardPayload,
): Promise<PatchDashboardV2Result> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchDashboardV2(
      namespace,
      dashboardId,
      payload,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update dashboard").message,
    };
  }
};
